<template>
  <div id="search_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Search Options</h5>
          <!-- {{formParam}} -->
          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4">From</label>
                        <div class="col-md-8">
                          <input
                            v-model="formParam.columnFilters.start_date"
                            type="date"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4">To</label>
                        <div class="col-md-8">
                          <input
                            v-model="formParam.columnFilters.end_date"
                            type="date"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4">Brand</label>
                        <div class="col-md-8">
                          <multiselect
                            v-model="selectedContact"
                            id="ajax"
                            label="name"
                            track-by="id"
                            :placeholder="'Type to search Brand...'"
                            :multiple="true"
                            open-direction="bottom"
                            :custom-label="customLabel"
                            :options="contactOptions"
                            :searchable="true"
                            :loading="isLoading"
                            :internal-search="false"
                            :close-on-select="false"
                            :options-limit="300"
                            :limit="3"
                            :limit-text="limitText"
                            :max-height="600"
                            :show-no-results="true"
                            :hide-selected="true"
                            @search-change="asyncFind"
                            :show-labels="false"
                          >
                            <template slot="tag" slot-scope="{ option, remove }">
                              <span class="custom__tag">
                                <span>{{option.name}}</span>
                                <span class="custom__remove" @click="remove(option)">❌</span>
                              </span>
                            </template>
                            <template slot="clear" slot-scope="props">
                              <div
                                class="multiselect__clear"
                                v-if="selectedContact.length"
                                @mousedown.prevent.stop="clearAll(props.search)"
                              ></div>
                            </template>
                            <span slot="noResult">Oops! No elements found.</span>
                          </multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group row">
                        <label class="col-form-label col-md-4">Product</label>
                        <div class="col-md-8">
                          <multiselect
                            v-if="selectedContact.length"
                            v-model="selectedProduct"
                            id="ajax"
                            label="name"
                            track-by="id"
                            :placeholder="'Type to search Product...'"
                            :multiple="true"
                            open-direction="bottom"
                            :custom-label="customLabel"
                            :options="productOptions"
                            :searchable="true"
                            :loading="isLoading"
                            :internal-search="false"
                            :close-on-select="false"
                            :options-limit="300"
                            :limit="3"
                            :limit-text="limitText"
                            :max-height="600"
                            :show-no-results="true"
                            :hide-selected="true"
                            @search-change="asyncFindProduct"
                            :show-labels="false"
                          >
                            <template slot="tag" slot-scope="{ option, remove }">
                              <span class="custom__tag">
                                <span>{{option.name}}</span>
                                <span class="custom__remove" @click="remove(option)">❌</span>
                              </span>
                            </template>
                            <template slot="clear" slot-scope="props">
                              <div
                                class="multiselect__clear"
                                v-if="selectedProduct.length"
                                @mousedown.prevent.stop="clearAll(props.search)"
                              ></div>
                            </template>
                            <span slot="noResult">Oops! No elements found.</span>
                          </multiselect>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group row">
                    <label class="col-form-label col-md-2">Keywords</label>
                    <div class="col-md-10">
                      <input
                        type="text"
                        class="form-control"
                        v-model="formParam.columnFilters.keywords_name"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group row">
                    <label class="col-form-label col-md-2">Hasil</label>
                    <div class="col-md-10">
                      <select
                        v-model="formParam.columnFilters.is_product_found"
                        class="form-control"
                      >
                        <option :value="''">Semua</option>
                        <option :value="'found'">Produk Ditemukan</option>
                        <option :value="'no'">Produk Tidak Ditemukan</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <center v-if="isSending==false">
                    <!-- {{isSending}} -->
                    <button @click.prevent="clearSearch" type="button" class="btn btn-md btn-light">
                      <i class="fa fa-trash"></i> Clear Filter
                    </button>
                    <button
                      @click.prevent="applySearch"
                      class="btn btn-md btn-success"
                      type="button"
                      :style="'margin-left:10px;'"
                    >
                      <i class="fa fa-search"></i> Search
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";

import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");
import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC
} from "@/utils/helper";
export default {
  components: {
    Skeleton,
    Multiselect
  },
  props: {
    searchData: {
      type: Function
    }
  },
  data() {
    return {
      selectedProduct: [],
      productOptions: [],
      productListParam: {
        brand_id: "",
        name: "",
        page: 0,
        perPage: 20
      },
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        name: "",
        page: 0,
        perPage: 20
      },
      isSending: false,
      formParam: {
        columnFilters: {
          start_date: "",
          end_date: "",
          product_id: "",
          brand_id: "",
          mp_id: "",
          is_product_found: "",
          keywords_name: ""
        },
        page: 1,
        perPage: 20,
        more_search: false
      },
      isLoading: false
    };
  },
  watch: {
    selectedProduct: {
      handler: function(val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedProduct = val;
        }
        if (val.length == 1) {
          this.formParam.columnFilters.product_id = val[0].id;
          // this.searchData();
        } else {
          this.formParam.columnFilters.product_id = "";
          // this.searchData();
        }
      },
      deep: true
    },
    selectedContact: {
      handler: function(val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedContact = val;
          // this.asyncFindProduct()
        }
        if (val.length == 1) {
          this.productOptions = [];
          this.selectedProduct = [];
          this.formParam.columnFilters.brand_id = val[0].id;
          this.asyncFindProduct();
          // this.searchData();
        } else {
          this.productOptions = [];
          this.selectedProduct = [];
          this.formParam.columnFilters.brand_id = "";
          // this.searchData();
        }
      },
      deep: true
    },
    isShowForm: {
      handler: function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          // this.selectedLicense = [];
          var that = this;
          setTimeout(function() {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            that.formParam = that.formParamListLogSt;
            that.asyncFind();
            // that.asyncFindProduct();
            // console.log("")
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    formParamListLogSt() {
      return this.$store.state.monitoring.formParamListLogSt;
    },
    isShowForm() {
      return this.$store.state.monitoring.isShowForm;
    }
  },
  filters: {
    capitalising: function(data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  methods: {
    async clearSearch() {
      let newFormParam = {
        columnFilters: {
          start_date: "",
          end_date: "",
          product_id: "",
          brand_id: "",
          mp_id: "",
          is_product_found: "",
          keywords_name: ""
        },
        page: 1,
        perPage: 20,
        more_search: false
      };
      await this.$store.dispatch(
        "monitoring/actFormParamListLogSt",
        newFormParam
      );
      this.searchData();
      // console.log("newFormParam", newFormParam);
      var elem = this.$refs.dismisModal;
      elem.click();
    },
    async applySearch() {
      let newFormParam = this.formParam;
      newFormParam.more_search = true;
      await this.$store.dispatch(
        "monitoring/actFormParamListLogSt",
        newFormParam
      );
      this.searchData();
      // console.log("newFormParam", newFormParam);
      var elem = this.$refs.dismisModal;
      elem.click();
    },
    asyncFindProduct(query) {
      if (this.selectedContact.length < 1) {
        return;
      }
      this.isLoading = true;
      this.productListParam.name = query;
      // console.log("selectedContact", this.selectedContact);
      this.productListParam.brand_id = this.selectedContact[0].id;
      this.$store
        .dispatch("brandProduct/list", this.productListParam)
        .then(response => {
          this.isLoading = false;
          this.productOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ name }) {
      return `${name}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.$store
        .dispatch("brand/list", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    clearAll() {
      this.selectedContact = [];
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>


// WEBPACK FOOTER //
// src/views/monitoring/logs/form.vue